import { render, staticRenderFns } from "./LegacyTimer.vue?vue&type=template&id=fbbc8a22&"
import script from "./LegacyTimer.vue?vue&type=script&lang=js&"
export * from "./LegacyTimer.vue?vue&type=script&lang=js&"
import style0 from "./LegacyTimer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports